import Vue from "vue";

import { URL_API } from "../../settings/apiConnect";

export default {
    actions: {
        async getPesticidesData(context) {
            const response = await Vue.axios.get(`${URL_API}pesticide`);
            let data = response["data"];
            context.commit("updatePesticidesData", data);
        },
        async createPesticideData(context, name, consumption_rate) {
            const config = {};
            const body = {
                name: name,
                consumption_rate: consumption_rate
            };
            await Vue.axios.post(`${URL_API}pesticide/store`, body, config);
            context.dispatch("getPesticidesData");
        },
        async pushPesticideData(context, { id, name, consumption_rate }) {
            const config = {};
            const body = {
                id: id,
                name: name,
                consumption_rate: consumption_rate,
            };
            await Vue.axios.post(`${URL_API}pesticide/update`, body, config);
            context.dispatch("getPesticidesData");
        },
        async destroyPesticideData(context, id) {
            const config = {};
            const body = {
                id: id
            };
            await Vue.axios.post(`${URL_API}pesticide/destroy`, body, config);
            context.dispatch("getPesticidesData");
        }
    },
    mutations: {
        updatePesticidesData(state, pesticidesData) {
            state.pesticidesData = pesticidesData;
        }
    },
    state: {
        pesticidesData: []
    },
    getters: {
        allPesticidesData(state) {
            return state.pesticidesData;
        }
    }
};